export default __webpack_public_path__ + "static/media/buy.792a4833.png";